import "@/lib/zod";
import { useForm as useRHFForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import type { ZodType } from "zod";
import type {
  DefaultValues,
  FieldValues,
  UseFormProps,
  UseFormReturn,
} from "react-hook-form";

interface ReturnType<T extends FieldValues> {
  form: UseFormReturn<T>;
  isSubmitDisabled: boolean;
}

type UseFormOptions<T extends FieldValues> = Omit<
  UseFormProps<T>,
  "resolver"
> & {
  defaultValues?: DefaultValues<T>;
};

export function useForm<T extends FieldValues>(
  schema: ZodType<T>,
  options?: UseFormOptions<T>,
): ReturnType<T> {
  const form = useRHFForm<T>({
    ...options,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    resolver: zodResolver(schema as any),
    mode: "all",
  });

  return {
    form,
    isSubmitDisabled: !form.formState.isValid || form.formState.isSubmitting,
  };
}
